import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTagIconinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M13 16.328V13.5a1.5 1.5 0 0 0-1.5-1.5H8.672a1.5 1.5 0 0 0-1.06.44L4.438 15.61A1.5 1.5 0 0 0 4 16.671c0 .399.158.78.44 1.061l2.828 2.829a1.5 1.5 0 0 0 2.121 0l3.172-3.172a1.5 1.5 0 0 0 .439-1.06",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M4 11V8a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2h-5M8.5 7V5.5A3.5 3.5 0 0 1 12 2v0a3.5 3.5 0 0 1 3.5 3.5V7M10 15zm-.001 0zl.001-.001"
	})]
});
export default SvgTagIconinline;
